"use client";

import { c as _c } from "react/compiler-runtime";
import { formatCountLabel } from "./wave-drops-scroll-controls.utils";
interface WaveDropsScrollControlsBottomButtonProps {
  readonly hasPending: boolean;
  readonly newMessagesCount: number;
  readonly isCombined: boolean;
  readonly combinedWidthClassName: string;
  readonly roundedClassName: string;
  readonly onRevealNewMessages?: (() => void) | undefined;
  readonly scrollToBottom: () => void;
}
export function WaveDropsScrollControlsBottomButton(t0) {
  const $ = _c(14);
  const {
    hasPending,
    newMessagesCount,
    isCombined,
    combinedWidthClassName,
    roundedClassName,
    onRevealNewMessages,
    scrollToBottom
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="tw-size-4 tw-flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" /></svg>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const bottomArrowIcon = t1;
  let t2;
  if ($[1] !== newMessagesCount) {
    t2 = formatCountLabel(newMessagesCount) ?? newMessagesCount;
    $[1] = newMessagesCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const newMessagesCountLabel = t2;
  let bottomContent = bottomArrowIcon;
  if (!isCombined && hasPending) {
    let t3;
    if ($[3] !== newMessagesCountLabel) {
      t3 = <span className="tw-text-sm tw-font-medium">{newMessagesCountLabel}</span>;
      $[3] = newMessagesCountLabel;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    bottomContent = t3;
  }
  let t3;
  if ($[5] !== hasPending || $[6] !== onRevealNewMessages || $[7] !== scrollToBottom) {
    t3 = () => {
      if (hasPending && onRevealNewMessages) {
        onRevealNewMessages();
        return;
      }
      scrollToBottom();
    };
    $[5] = hasPending;
    $[6] = onRevealNewMessages;
    $[7] = scrollToBottom;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleBottomClick = t3;
  const t4 = `tw-flex tw-h-10 tw-min-w-[2.75rem] tw-flex-shrink-0 tw-items-center tw-justify-center tw-gap-2 tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-700 tw-px-4 tw-text-iron-300 tw-transition-all tw-duration-300 hover:tw-border-iron-650 hover:tw-bg-iron-650 lg:tw-h-8 ${roundedClassName} ${isCombined ? combinedWidthClassName : ""}`;
  const t5 = hasPending ? "Reveal new messages" : "Scroll to bottom";
  let t6;
  if ($[9] !== bottomContent || $[10] !== handleBottomClick || $[11] !== t4 || $[12] !== t5) {
    t6 = <button onClick={handleBottomClick} className={t4} aria-label={t5}>{bottomContent}</button>;
    $[9] = bottomContent;
    $[10] = handleBottomClick;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}